import { Component, computed, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { MATERIAL_CORE } from '@siat-fe/core';
import { WidgetDataStore } from '../../../../stores/widget-data.store';
import { CountGridWidget, CountGridWidgetData } from '../../models';

@Component({
  selector: 'siat-count-grid-widget',
  templateUrl: './count-grid-widget.component.html',
  styleUrl: './count-grid-widget.component.scss',
  imports: [MATERIAL_CORE],
})
export class CountGridWidgetComponent {
  /**
   * The widget data store.
   */
  private widgetDataStore = inject(WidgetDataStore);
  private router = inject(Router);

  /**
   * The widget.
   */
  widget = input.required<CountGridWidget>();

  /**
   * The widget data as an array of grid items.
   */
  widgetData = computed<CountGridWidgetData[]>(() => {
    const data = this.widgetDataStore.getWidgetData<CountGridWidgetData[]>(
      this.widget()?.id
    );
    return Array.isArray(data)
      ? data.filter(w => w?.maxGiorniTag && w?.maxGiorniTag != 0)
      : [];
  });

  onItemClick(item: CountGridWidgetData): void {
    const basePath = this.widget().config?.api?.detail;
    const numSegnalazioni = item.numSegnalazioniRitardo;
    void this.router.navigate([`/home/${basePath}`], {
      queryParams: {
        nomeTag: item.tag,
        stati: 'NON_IN_GESTIONE,IN_GESTIONE',
        numSegnalazioni: numSegnalazioni,
        expiredReportsOnly: true,
      },
      state: {
        idSegnalazioni:
          item.numSegnalazioniRitardo > 0 ? item.idSegnalazioni : [-1],
      },
    });
  }

  /**
   * Returns a fixed color based on percentage ranges.
   * 0-25: green, 25-75: orange, 75-100: red
   */
  getPercentageColor(percentuale: number): string {
    const clamped = Math.max(0, Math.min(100, percentuale ?? 0));
    if (clamped <= 25) return '#00843B';
    if (clamped <= 75) return '#E16500';
    return '#B21212';
  }

  /**
   * Returns inline styles for the progress bar based on percentage.
   */
  getProgressBarStyle(percentuale: number): { [key: string]: string } {
    const clamped = Math.max(0, Math.min(100, percentuale ?? 0));
    const color = this.getPercentageColor(clamped);
    const colorFaded = `${color}1A`;
    return {
      background: `linear-gradient(to right, ${color} ${clamped}%, ${colorFaded} ${clamped}%)`,
      border: `1px solid ${color}`,
      'border-radius': '8px',
    };
  }
}
